import Notification from '@rio-cloud/rio-uikit/Notification';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export function nonVanishingErrorNotification(message: string | ReactNode, errorCode: string, dataAttribute?: string) {
    return Notification.error(
        <span data-cy={dataAttribute}>
            {message}
            <hr />
            {`Error Code: ${errorCode}`}
            <span className={'notification-close'}>
                <span className='rioglyph rioglyph-remove' />
            </span>
        </span>,
        { title: '', timeout: 1000 * 5, callback: () => {} }
    );
}

export function nonVanishingFormattedErrorNotification(
    messageId: string | ReactNode,
    errorCode: string,
    _dataAttribute?: string
) {
    return nonVanishingErrorNotification(<FormattedMessage id={`${messageId}`} />, errorCode);
}

export function closableSuccessNotification(message: string | ReactNode, dataAttribute?: string) {
    return Notification.success(
        <span data-cy={dataAttribute}>
            {message}
            <span className={'notification-close'}>
                <span className='rioglyph rioglyph-remove' />
            </span>
        </span>,
        { title: '', timeout: 1000 * 5, callback: () => {} }
    );
}
export function closableSuccessFormattedNotification(messageId: string | ReactNode, _dataAttribute?: string) {
    return closableSuccessNotification(<FormattedMessage id={`${messageId}`} />);
}
